import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { services } from "../data/services";
import { IconCheck } from "../components/Icon";
import { CTA } from "../components/sections/CTA";
import { breadcrumbJsonLd, localBusinessJsonLd, serviceJsonLd } from "../lib/structured-data";
import { site } from "../lib/site";

export function Services() {
  return (
    <>
      <SEO
        title="Services de nettoyage à Vichy - Bureaux, copropriétés, vitres, chantier"
        description="Découvrez nos services de nettoyage professionnel à Vichy : bureaux, copropriétés, commerces, Airbnb / locations courtes durées, vitres, fin de chantier et ménage chez les particuliers."
        path="/services"
        jsonLd={[
          localBusinessJsonLd(),
          breadcrumbJsonLd([
            { name: "Accueil", url: `${site.baseUrl}/` },
            { name: "Services", url: `${site.baseUrl}/services` },
          ]),
          ...services.map((s) => serviceJsonLd(s.title, s.short, s.slug)),
        ]}
      />
      <PageHeader
        eyebrow="Nos services"
        title="Des prestations de nettoyage complètes à Vichy et en Allier"
        subtitle="Chaque site, chaque activité a ses exigences. Nous construisons avec vous un cahier des charges sur-mesure, avec un interlocuteur unique et du matériel professionnel."
        breadcrumbs={[{ label: "Accueil", to: "/" }, { label: "Services" }]}
      />

      <section className="section bg-white">
        <div className="container-page space-y-12">
          {services.map((s, i) => (
            <article
              key={s.id}
              id={s.id}
              className={`grid gap-8 lg:grid-cols-12 items-start rounded-3xl bg-surface-soft border border-slate-200 p-6 sm:p-10 scroll-mt-24 ${
                i % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className="lg:col-span-5">
                <div className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-600 text-white">
                  <s.icon className="h-7 w-7" />
                </div>
                <h2 className="mt-5 text-3xl">{s.title}</h2>
                <p className="mt-4 text-ink-muted text-lg">{s.long}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {s.keywords.map((k) => (
                    <span
                      key={k}
                      className="inline-flex items-center rounded-full bg-brand-100 px-3 py-1 text-xs font-medium text-brand-800"
                    >
                      {k}
                    </span>
                  ))}
                </div>
              </div>
              <div className="lg:col-span-7">
                <ul className="grid sm:grid-cols-2 gap-3">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex gap-3 rounded-xl bg-white border border-slate-200 p-4"
                    >
                      <span className="grid h-7 w-7 place-items-center rounded-lg bg-accent-500/15 text-accent-600 flex-none">
                        <IconCheck className="h-4 w-4" />
                      </span>
                      <span className="text-sm text-ink leading-snug">{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CTA />
    </>
  );
}
